export const selectors = {
	player: '.episode-player',
	stickyPlayer: '.sticky-episode-player',
	audio: 'audio',
	firstAudio: 'audio:first-of-type',
	audioFull: 'audio[data-version="full"]',
	audioShort: 'audio[data-version="short"]',
	playlist: '.episode-player__playlist',
	playlistEpisode: '.episode',
	playlistEpisodeDuration: '.episode__duration',
	playlistActiveEpisode: '.episode.selected',
	btnPlayPause: 'button.playpause',
	btnSkipBackward: 'button.skip-backward',
	btnSkipForward: 'button.skip-forward',
	timeCurrent: '.time__current',
	timeTotal: '.time__total',
	progressBar: '.seek-slider',
	externalControl: '.episode-external-control',
	externalControlPlayBtn: '.episode-external-control__playpause',
	externalControlCloseBtn: 'button.close',
	externalControlDuration: '.duration',
};

export const classNames = {
	episodeActive: 'selected',
	showStickyPlayer: 'show',
};

export const skipBtnTime = 10;
